import { BaseDevice } from "./base.device";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_CLIENT, BaseClient } from "../client/base.client";
import { ITitle } from "./model/title";
import { map } from "rxjs/operators";
import { preloaderFinished } from "../auth/preloader";
import { Itoken } from "../auth/itoken";
import { IWindow } from "./model/window";
import { from, Observable, of } from "rxjs";
import { NavigationBar } from "./model/navigationbar";
import { UserLocation } from "./model/location";
import { Title } from "@angular/platform-browser";
import { TokenService } from "../token/token.service";
import { UserService } from "../user/user.service";
import { IUser } from "../user/user.interface";

@Injectable({
  providedIn: "root"
})
export class Browser extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    @Inject(BASE_CLIENT) private baseclient: BaseClient,
    private title: Title
  ) {
    super();
  }

  auth(): Promise<any> {
    if (this.baseclient.browser && this.baseclient.browser.auth === false) {
      return new Promise<any>((resolve, reject) => {
        preloaderFinished();
        resolve(true);
      });
    }
    // 如果是本地开发配置了账号密码
    if (this.baseclient.dev && this.baseclient.dev.username && this.baseclient.dev.password) {
      return new Promise<any>((resolve, reject) => {
        this.authByConfiguredUserPass().then(() => {
          this.http
            .get(`${this.baseclient.gateway}/auth/user`)
            .subscribe((response: any) => {
              this.user.set({ ...response.principal, tenantId: response.tenantId });
              preloaderFinished();
              resolve(true);
            });
        });
      });
    }
    // 走cas认证流程
    return new Promise<any>((resolve, reject) => {
      this.authByCas().then(() => {
        this.http
          .get(`${this.baseclient.gateway}/auth/user`)
          .subscribe((response: any) => {
            this.user.set({ ...response.principal, tenantId: response.tenantId });
            preloaderFinished();
            resolve(true);
          });
      });
    });
  }


  private authByCas(): Promise<void> {
    const url = encodeURIComponent(window.location.href);
    return this.http.get(this.baseclient.gateway + '/cas-proxy/app/validate_full?callback=' + url + '&timestamp=' + new Date().getTime())
      .pipe(
        map((res: any) => {
          switch (res.errcode) {
            case 2000:
              const token: any = {};
              token.tokenType = res.data.token_type;
              token.accessToken = res.data.access_token;
              token.scope = res.data.scope;
              token.tokenDateLine = res.data.expires_in;
              this.tokenService.set(token);
              break;
            case 2001:
              window.location.href = res.msg;
              break;
            case 2002:
              alert(res.data);
              break;
            case 2003:
            case 5000:
            case 5001:
              alert(res.msg);
              break;
            default:
              break;
          }
        })
      ).toPromise();
  }

  private authByConfiguredUserPass(): Promise<void> {
    const form: FormData = new FormData();
    form.set('username', this.baseclient.dev.username);
    form.set('password', this.baseclient.dev.password);
    form.set('grant_type', 'password');
    form.set('client_id', 'webapp');
    form.set('scope', 'webapp');
    form.set('client_secret', '123456');

    return this.http
      .post(`${this.baseclient.gateway}/auth/oauth/token`, form)
      .pipe(
        map((response: any) => {
          const token: any = {};
          token.tokenType = response.token_type;
          token.accessToken = response.access_token;
          token.scope = response.scope;
          token.tokenDateLine = response.expires_in;
          this.tokenService.set(token);
        })
      )
      .toPromise();
  }

  getToken(): Itoken {
    const itoken: Itoken = {
      accessToken: this.tokenService.get().accessToken,
      tokenType: this.tokenService.get().tokenType,
      tokenDataLine: this.tokenService.get().tokenDateLine,
      scope: this.tokenService.get().scope
    };
    return itoken;
  }

  getUser(): IUser {
    const iuser: IUser = Object.create({
      account: this.user.get().username,
      userName: this.user.get().username,
      password: this.user.get().password,
      userId: this.user.get().id,
      realName: this.user.get().realname,
      deptId: this.user.get().deptId,
      deptName: this.user.get().deptName,
      userType: this.user.get().userType
    });
    return iuser;
  }

  openWindow(iwindow: IWindow): void {
    window.location.href = iwindow.url;
  }

  scanCode(): Observable<string> {
    alert("浏览器暂不支持扫码,请在APP中使用此功能!");
    return of("浏览器暂不支持扫码,请在APP中使用此功能!");
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    alert("浏览器暂不支持放置按钮,请在APP中使用此功能!");
  }

  setTitle(ititle: ITitle): void {
    this.title.setTitle(ititle.title);
  }

  share(): void {
    alert("浏览器暂不支持分享,请在APP中使用此功能!");
  }

  userLocation(): Observable<UserLocation> {
    alert("浏览器暂不支持定位,请在APP中使用此功能!");
    return of(null);
  }

  validateInWifi(bssids: Array<string>): Observable<boolean> {
    alert("浏览器暂不支持WIFI验证,请在APP中使用此功能!");
    return of(null);
  }

  getWifiMac(): Observable<string> {
    alert("浏览器暂不支持获取MAC地址,请在APP中使用此功能!");
    return of("浏览器暂不支持获取MAC地址,请在APP中使用此功能!");
  }

  chooseContacts(count: number): Observable<any> {
    alert("浏览器暂不支持获取联系人,请在APP中使用此功能!");
    return of("浏览器暂不支持获取联系人,请在APP中使用此功能!");
  }

  contactDetails(targetUserId: string): Observable<any> {
    alert("浏览器暂不支持查询联系人详细信息,请在APP中使用此功能!");
    return of("浏览器暂不支持查询联系人详细信息,请在APP中使用此功能!");
  }

  uploadImage(count: number, sourceType: any): Observable<any> {
    alert('浏览器暂不支持图片上传,请在APP中使用此功能!');
    return undefined;
  }

  openReadWithTimer(url: any, openType: any, title: any, id: any, type: any): Observable<any> {
    alert('浏览器暂不支持读物时间统计,请在APP中使用此功能!');
    return undefined;
  }
  uploadMovie(limitMinute: number): Observable<any> {
    alert('浏览器暂不支持视频上传,请在APP中使用此功能!');
    return undefined;
  }
  fileBrowser(url: string,title:string): Observable<any> {
    alert('浏览器暂不支持此功能,请在APP中使用此功能!');
    return undefined;
  }
  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
  stopSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
  onSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
}
